import { Component, OnInit } from '@angular/core';
import { BlogService } from '../services/blog.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Subject, Observable } from 'rxjs';
import { SkillService } from '../../skill-matrix/services/skill.service';
import { ByEmployee } from '../../skill-matrix/api-interfaces';
import { FlashService } from '../../flash/flash.service';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-admin-blog-post',
  templateUrl: './admin-blog-post.component.html',
  styleUrls: ['./admin-blog-post.component.css']
})
export class AdminBlogPostComponent implements OnInit {
  blog;
  blogForm: FormGroup;
  employeeDetail: Observable<ByEmployee>
  private destroy: Subject<void> = new Subject<void>();
  private urlValidate: RegExp = new RegExp(/(https)?:\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);

  constructor(
    public blogService: BlogService,
    private formBuilder: FormBuilder,
    private location: Location,
    public skillService: SkillService,
    public flashService: FlashService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,

  ) {
    this.employeeDetail = this.skillService.getEmployee();
    const date = new Date();
    this.blogForm = this.formBuilder.group({
      title: new FormControl('', Validators.required),
      url: new FormControl('', [Validators.pattern(this.urlValidate)]),
      emp_id: new FormControl('', Validators.required),
      submission_date: new FormControl(this.stringToDate(date), Validators.required),
      published_date: new FormControl(this.stringToDate(date), Validators.required),
    });
  }

  ngOnInit() {
  }

  locationBack() {
    this.location.back();
  }

  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: (value.getMonth() + 1),
        day: (value.getDate())
      }
    };
    return dateObject;
  }
  dateToString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }

  onSubmit(formData) {
    this.spinnerService.show();
    if (formData.valid) {
      this.spinnerService.hide();
      formData.value.submission_date = this.dateToString(formData.value.submission_date);
      formData.value.published_date = this.dateToString(formData.value.published_date);
      this.blogService.blogPost(formData.value).takeUntil(this.destroy)
        .subscribe(data => {
          this.blog = data;
          this.router.navigateByUrl('blogList');
          this.flashService.show('New blog has been added successfully', 'alert-success');
        })
    }
    else {
      this.spinnerService.hide();
      Object.keys(this.blogForm.controls)
        .forEach(controlName => this.blogForm.controls[controlName].markAsTouched());
      this.flashService.show('Please enter the correct details', 'alert-danger');
    }
  }
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/blog/admin-blog-post/admin-blog-post.component.ts